import React from 'react'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonList, FigureCards, NewsCard, SuccessStories, CommonBlueCards, PlainText } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './communications.scss'

const Communications = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/whoweserve" },
    { label: "Service industry insurance", link: "/whoweserve/serviceindustries" },
    { label: "Communications businesses insurance", link: "/whoweserve/serviceindustries/communications-businesses-insurance" },
  ];



  const HeaderData = [
    {
      para: 'As technology and communications continually advance, your business is constantly evolving. Your business insurance should adapt to that change too. We believe that one size doesn’t really fit all, which is why we get to know your cable, internet, or other communications business before helping you determine what coverages are best for you.',
      para1: 'Are you a national accounts broker or part of a large business looking for loss-sensitive program options? We offer specialized services for national accounts and brokers.'
    },
  ]; 

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const Datalist = [
    "Bundled and unbundled loss control and industrial hygiene services ",
    "Loss sensitive workers’ compensation insurance coverages",
    "Powerful cost-control tools",
  ];

  const revenueData = [
    {
      id: 1,
      value: "8",
      unit: "Sentry leaders",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 2,
      value: "$1B+",
      unit: "Paid in claims",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 3,
      value: "1992",
      unit: "First year",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Physical damage insurance',
      description:
        'Weather, animals, other drivers—all things that can damage your vehicle. Let us help cover your costs with physical damage insurance.',
      linkUrl: '',
      linkText: 'More about physical damage insurance >',
    },
    {
      id: 2,
      title: 'Cyber liability insurance',
      description:
        'Data breaches. While we hope they never happen to your business, they are a potential risk. Help protect your company with cyber liability coverage.',
      linkUrl: '/',
      linkText: 'More about cyber liability insurance >',
    },
    {
      id: 3,
      title: 'General liability insurance',
      description:
        'We offer protection against liability claims for your business. Coverage options include product liability, product recall, and errors and omissions.',
      linkUrl: '/',
      linkText: 'More about general liability insurance >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Construction resources',
      description:
        'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  const plaindata = [
    {
      heading: "We focus on your claims, so you can stay focused on your communications business",
      text: "Claims happen. And when they do, our in-house claims management team is ready to help your communications business. We can take care of cost-containment, investigation, litigation, and even special instructions from you. No matter the size or difficulty of the claim, we’ll work to take care of it promptly and accurately, so you can keep moving your business forward.",
      linkText: "View resources",
      linkUrl: "/resources"
    },
  ]

  return (
    <>
      <div className='Communications-insurance-main'>
        {/* hero section */}
        <Hero img={images["People_reviewing_paperwork.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Insurance for communications businesses" showshare={true} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} showImage={false} />

          {/*common list section */}
          <CommonList Heading="We can offer communications businesses:" list={Datalist} />

          {/* heading text */}
          <PlainText data={plaindata} />

          {/* figure cards */}
          <FigureCards data={revenueData} heading={'Significant figures'} />

          {/* products cards */}
          <NewsCard Title="Products for your business" CardData={ProductCardData} showNavLink={false} subTitle="PRODUCTS" />

          {/* success stories */}
          <SuccessStories />

          {/* resorce data */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources or services" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default Communications;